import { globalConfigService } from '@syscolect/application'
import { useEffect, useState, type ReactNode } from 'react'
import { env } from '@/config/env'

export function ConfigGate({ children }: { children: ReactNode }) {
  const [state, setState] = useState<'loading' | 'ready' | 'error'>('loading')
  const [message, setMessage] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    // Inject the env-level System API HTTP host override (highest precedence:
    // env → globalConfig/dev → globalConfig/default). Console owns env access.
    globalConfigService.setSystemApiHostOverride(env.systemApiHost)
    globalConfigService
      .load(env.appEnvironment === 'development')
      .then(() => {
        if (!cancelled) setState('ready')
      })
      .catch((err) => {
        if (cancelled) return
        setMessage(err instanceof Error ? err.message : 'Falha ao carregar configurações')
        setState('error')
      })
    return () => {
      cancelled = true
    }
  }, [])

  if (state === 'loading')
    return (
      <div className="grid min-h-screen place-items-center bg-bg text-fg-muted">
        Carregando configurações…
      </div>
    )

  if (state === 'error')
    return (
      <div className="grid min-h-screen place-items-center bg-bg p-4 text-center text-destructive">
        <div>
          <p className="font-medium">Não foi possível carregar configurações.</p>
          {message ? <p className="mt-1 text-xs text-fg-muted">{message}</p> : null}
        </div>
      </div>
    )

  return <>{children}</>
}
